import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=1a492830&"
import script from "./ScrollTop.vue?vue&type=script&lang=js&"
export * from "./ScrollTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a492830')) {
      api.createRecord('1a492830', component.options)
    } else {
      api.reload('1a492830', component.options)
    }
    module.hot.accept("./ScrollTop.vue?vue&type=template&id=1a492830&", function () {
      api.rerender('1a492830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/ScrollTop.vue"
export default component.exports